





































































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { PaginationPanel, DraggerImg } from '@/components';
import countTo from 'vue-count-to';
import collapse from '../../utils/collapse.js';
import echarts from 'echarts';
import ListFilterPanel from '@/components/ListFilterPanel.vue';
import publicFunc from '@/common/util/publicFunc';
import { formRules } from '@/common/util/validator';
import { enums } from '@/common/enums';
import { Carrier, Kpi } from '@/http';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        PageDescribe,
        DataPanel,
        PaginationPanel,
        collapse,
        ListFilterPanel,
        countTo,
        DraggerImg,
    },
})
export default class carrierPortrait extends Vue {
    public activeName = 'first';
    public loading = false;
    public rePagin = false;
    public total = 0;
    expireTimeOption = {
        // disabledDate(date) {
        //     //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
        //     return (
        //         date.getTime() < new Date(new Date().getFullYear(), 0, 1).getTime() ||
        //         date.getTime() > new Date(new Date().getFullYear(), 11, 31).getTime()
        //     );
        // },
    };

    format(percentage) {
        return `${percentage}`;
    }

    format2(percentage) {
        if (this.isHasKpi) {
            return `${percentage}`;
        } else {
            return '暂无数据';
        }
    }

    public sort(col): void {
        if (col.order == 'ascending') {
            this.searchValue.isAsc = true;
        } else {
            this.searchValue.isAsc = false;
        }
        switch (col.prop) {
            case 'creationTime':
                {
                    this.searchValue.orderBy = '1';
                }
                break;
        }
        this.loadData();
    }

    public formData: any = {};

    public carrierId: any = '';
    mounted() {
        this.carrierId = this.$route.query.id;
        this.detectZoom();
        this.$nextTick(() => {
            window.addEventListener('resize', () => {
                // 监听浏览器窗口大小改变
                this.detectZoom();
                // 浏览器变化执行动作
            });
        });
        this.getRadarData();
        console.log('this.ratio' + this.ratio);
    }

    // 方法
    // 方法
    public ratio = 0;
    detectZoom() {
        this.ratio = 0;
        const screen: any = window.screen;
        const ua = navigator.userAgent.toLowerCase();
        if (window.devicePixelRatio !== undefined) {
            this.ratio = window.devicePixelRatio;
        } else if (~ua.indexOf('msie')) {
            if (screen.deviceXDPI && screen.logicalXDPI) {
                this.ratio = screen.deviceXDPI / screen.logicalXDPI;
            }
        } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
            this.ratio = window.outerWidth / window.innerWidth;
        }
        if (this.ratio) {
            this.ratio = Math.round(this.ratio * 100);
        }
        if (this.ratio >= 125 && this.ratio > 100) {
            console.log('333');
            this.radarOption.radar.radius = 120;
        } else if (this.ratio < 125 && this.ratio >= 150) {
            console.log('222');
            this.radarOption.radar.radius = 80;
        } else {
            console.log('111');
            this.radarOption.radar.radius = 160;
        }
        console.log('this.radarOption.radar.radius' + this.radarOption.radar.radius);
        setTimeout(() => {
            this.initRaderChart();
        }, 400);
    }

    public isHasKpi = false;
    public async getRadarData() {
        let res = await Kpi.GetCarrierPortrait({ carrierId: this.carrierId });
        this.isHasKpi = res.isHasKpi;
        if (!res.isHasKpi) {
            this.$alert('请新增KPI考核!', '提示');
        }
        this.$nextTick(() => {
            this.formData = res;
            this.radarOption.series[0].name = res.carrierName;
            this.radarOption.series[0]['data'][0].value = [
                res.inquiryPrescription,
                res.logisticsPrescription,
                res.logisticsQuality,
                res.satisfaction_,
                res.siteManagement,
            ];
            console.log(' this.radarOption.series[0]' + JSON.stringify(this.radarOption.series[0]));
            this.initRaderChart();
        });

        console.log(' this.formData ' + JSON.stringify(this.formData));
        //。。。获取雷达数据
        //。。。赋值
    }

    public initRaderChart() {
        document.getElementById('Rader').removeAttribute('_echarts_instance_');
        let radarDiv = document.getElementById('Rader');
        let radarChart = echarts.init(radarDiv);
        radarChart.setOption(this.radarOption);
    }
    public handleCheckedChange() {
        let newDate = this.colData.filter((item) => item.isShow == false);
        if (this.colData.length - newDate.length == 3) {
            this.$message.warning('至少选择3个');
            this.colData.forEach((item) => {
                if (item.isShow) {
                    item.disabled = true;
                }
            });
        } else {
            this.colData.forEach((item) => {
                item.disabled = false;
            });
        }
        localStorage.setItem('carrierPortrait', JSON.stringify(this.colData));
    }
    public colData = JSON.parse(localStorage.getItem('carrierPortrait'))
        ? JSON.parse(localStorage.getItem('carrierPortrait'))
        : [
              { title: '考核周期', isShow: true, disabled: false },
              { title: '发货及时率', isShow: true, disabled: false },
              { title: '报价及时率', isShow: true, disabled: false },
              { title: '回单及时率', isShow: true, disabled: false },
              { title: '产品货损', isShow: true, disabled: false },
              { title: '现场管理', isShow: true, disabled: false },
              { title: '满意度', isShow: true, disabled: false },
              { title: '综合得分', isShow: true, disabled: false },
              { title: '创建时间', isShow: true, disabled: false },
          ];

    handleClick(tab, event) {
        console.log(tab, event);
        if (tab.index == '1') {
            this.loadData();
        }
    }

    public async loadData() {
        this.loading = true;
        await Kpi.GetKpiDetailList({
            ...this.searchValue,
            carrierId: this.carrierId,
            skip: this.searchPagin.skip,
            count: this.searchPagin.count,
        })
            .then((res) => {
                this.tableData = res.data;
                let skip = this.searchPagin.skip;
                this.tableData.map((item, index) => {
                    item.index = skip++ + 1;
                });
                this.total = res.total;
                this.loading = false;
            })
            .catch((err) => {
                this.loading = false;
            });
        if (this.total > 0 && this.tableData.length == 0) {
            this.searchPagin.skip = 0;
            this.loadData();
        }
    }
    public $refs: {
        pagination: HTMLFormElement;
        multipleTable: HTMLFormElement;
    };
    public searchValue: any = {
        cycle: '',
        isAsc: false,
    };
    public resetSearchValue() {
        this.searchValue = {
            cycle: '',
            isAsc: false,
        };
        this.$refs.pagination.resetSize();
        this.$refs.multipleTable.clearSort();
        this.$refs.pagination.handleSizeChange(10);
        this.searchFunc();
    }
    public searchFunc() {
        sessionStorage.setItem('carrierPortrait_searchValue', JSON.stringify(this.searchValue));
        this.$refs.pagination.handleCurrentChange(1);
        this.searchPagin.skip = 0;
        this.loadData();
    }
    public tableData: any = [];
    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };

    public back() {
        this.$router.back();
    }

    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        sessionStorage.setItem('carrierPortrait_page', JSON.stringify(pagin));
        this.getList();
    }

    public getList() {}

    public async exportExcel() {
        let data = await Kpi.Export({ carrierId: this.carrierId, ...this.searchValue });
    }

    radarOption: any = {
        color: ['#A3B5FF', '#A3B5FF'],
        tooltip: {
            trigger: 'item',
        },
        radar: {
            indicator: [
                { name: '询价时效', max: 100 },
                { name: '物流时效', max: 100 },
                { name: '物流质量', max: 100 },
                { name: '满意度', max: 100 },
                { name: '现场管理', max: 100 },
            ],
            radius: 160,
            name: {
                color: '#000',
                fontSize: 14,
                fontWeight: 700,
                fontFamily: 'SinoFont',
            },
            splitArea: {
                show: false,
                areaStyle: {
                    color: 'rgba(255,0,0,0)', // 图表背景的颜色
                },
            },
            axisLine: {
                lineStyle: {
                    color: '#ABABAD',
                },
            },
            splitLine: {
                show: true,
                lineStyle: {
                    width: 1,
                    color: '#ABABAD', // 设置网格的颜色
                },
            },
        },

        series: [
            {
                name: '',
                type: 'radar',
                data: [
                    {
                        value: [],
                        // label: {
                        //     show: true,
                        //     formatter: function (params) {
                        //         return params.value;
                        //     },
                        // },

                        areaStyle: {
                            color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                                {
                                    color: 'rgba(163,181,255, 1)',
                                    offset: 1,
                                },
                                {
                                    color: 'rgba(163,181,255, 1)',
                                    offset: 1,
                                },
                            ]),
                        },
                    },
                ],
            },
        ],
    };
    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            //给每一行添加不可枚举属性rowIndex来标识当前行
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }
}
